(function () {
  'use strict';

  var TRACKING_KEYS = [
    'flow', 'traffic_flow_id',
    'utm_source', 'utm_site', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'pbid', 'redditpix'
  ];
  var FLOW_KEYS = ['flow', 'traffic_flow_id'];

  var STORAGE_KEY = 'omni_attribution';
  var COOKIE_DAYS = 90;

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { }

    var m = document.cookie.match(new RegExp('(?:^|; )' + STORAGE_KEY + '=([^;]*)'));
    if (m) {
      try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { }
    }
    return null;
  }

  function writeStored(data) {
    var json = JSON.stringify(data);
    try { window.localStorage.setItem(STORAGE_KEY, json); } catch (e) { /* игнор */ }
    var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = STORAGE_KEY + '=' + encodeURIComponent(json) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function paramsFromUrl() {
    var out = {};
    try {
      var sp = new URLSearchParams(window.location.search);
      TRACKING_KEYS.forEach(function (key) {
        var v = sp.get(key);
        if (v !== null && v !== '') out[key] = v;
      });
    } catch (e) {  }
    return out;
  }

  function hasFlow(obj) {
    return FLOW_KEYS.some(function (k) { return obj[k]; });
  }

  function applyToCart(data) {
    if (!data || !Object.keys(data).length) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: data })
      }).catch(function () {  });
    } catch (e) {  }
  }

  function initRedditPixel(pixelId) {
    if (!pixelId) return;
    !function (w, d) {
      if (!w.rdt) {
        var p = w.rdt = function () {
          p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
        };
        p.callQueue = [];
        var t = d.createElement('script');
        t.src = 'https://www.redditstatic.com/ads/pixel.js';
        t.async = true;
        var s = d.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(t, s);
      }
    }(window, document);
    window.rdt('init', pixelId);
    window.rdt('track', 'PageVisit');
  }

  var stored = readStored();
  var fromUrl = paramsFromUrl();

  if (hasFlow(fromUrl)) {
    stored = fromUrl;
    writeStored(stored);
  }

  if (stored) {
    applyToCart(stored);
  }

  initRedditPixel(stored && stored.redditpix);
})();